module.exports = __webpack_public_path__ + "static/media/fem_3.35dd0eb9.png";